var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"text"},[_vm._v("欢迎使用"+_vm._s(_vm.name)+"系统")]),_c('img',{staticClass:"bg-img",attrs:{"src":require("../../assets/home/bg.png"),"alt":"","draggable":"false"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }